import react from "react";
import Request from "../../../../api/Requests";

const getPaymentsList = (params) => {
    return Request('admin/payments-list', 'GET', params, true);
}

const getPaymentsDetails = (params) => {
    return Request('admin/payments-details', 'GET', params, true);
}

const setPaymentsAccept = (params) => {
    return Request('admin/payments-accept', 'POST', params, true);
}

export default {
    getPaymentsList,
    getPaymentsDetails,
    setPaymentsAccept
}